var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoostConversationRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100.0 100.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332,0 C336.418278,-8.11624501e-16 340,3.581722 340,8 L340,406 C340,410.418278 336.418278,414 332,414 L8,414 C3.581722,414 2.705415e-16,410.418278 0,406 L0,8 C-5.41083001e-16,3.581722 3.581722,5.41083001e-16 8,0 L332,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C77.5701172,0 100,22.4296875 100,49.9994141 C97.4964844,116.222656 2.51367188,116.240625 0,50 C0,22.4298828 22.4298828,0 50,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i3",
    x1: "-9.37762319px",
    y1: "-38.1678302px",
    x2: "99.2993979px",
    y2: "122.162176px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9811146,0 C45.5021412,0 58.2021818,9.87448655 58.2021818,22.7539714 C58.2021818,35.6334562 45.5002965,45.345741 28.9792699,45.345741 C28.4369149,45.345741 27.9040614,45.3187555 27.3694103,45.2900371 L27.0214506,45.2719643 C26.8291097,45.2484448 26.625213,45.3115759 26.457011,45.4197653 L12.678575,53.6050157 L12.678575,42.4870167 C12.678575,42.1443758 12.4767327,41.830701 12.1588182,41.6794339 C2.10907269,36.8898887 3.98614475e-12,28.7439976 3.98614475e-12,22.7539714 C3.98614475e-12,9.87448655 12.460088,0 28.9811146,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6825638,0.409379199 C10.9134818,0.0437540878 11.3778375,-0.0986873616 11.7726423,0.0712345649 C12.1700252,0.242035398 12.3837753,0.675512092 12.2781893,1.09521925 L9.66033693,11.4844216 L16.6993234,11.4844216 C17.0194798,11.4844216 17.3147338,11.6586795 17.4692455,11.9393436 C17.6237573,12.2191289 17.6134448,12.5616094 17.442644,12.83284 L6.89576578,29.5906576 C6.66396883,29.95681 6.20254291,30.0984312 5.80568732,29.9288022 C5.4082458,29.7580014 5.19455433,29.3245833 5.3001403,28.9048175 L7.91799265,18.5156152 L0.879006143,18.5156152 C0.558849796,18.5156152 0.2635958,18.3413573 0.109084034,18.0606931 C-0.0454277313,17.7809079 -0.0351152281,17.4384273 0.135685605,17.1671968 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i6",
    x1: "-3.27110842px",
    y1: "-15.4915px",
    x2: "17.5783296px",
    y2: "37.5557179px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168.0 -244.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.0 178.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.0 66.00000000000097)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 100,0 100,99.6736575 0,99.6736575 0,0",
    stroke: "none",
    fill: "url(#i3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.20218181818188 24.0) scale(-1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.98614475e-12,0 58.2021818,0 58.2021818,53.6050157 3.98614475e-12,53.6050157 3.98614475e-12,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.0 32.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.22044605e-16,1.38777878e-17 17.5783296,1.38777878e-17 17.5783296,30 -2.22044605e-16,30 -2.22044605e-16,1.38777878e-17",
    stroke: "none",
    fill: "url(#i6)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoostConversationRed);
export default __webpack_public_path__ + "static/media/icBoostConversationRed.20d785ac5bd233ebd09d329ad4290df2.svg";
export { ForwardRef as ReactComponent };